module.exports = __webpack_public_path__ + "static/media/curve-one-light-orange.79f347db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-Images/curve-one-light-orange.png
// module id = 128
// module chunks = 0